const API_HOST = process.env.API_HOST;
const API_PORT = process.env.API_PORT;
const CMS_API_HOST = process.env.CMS_API_HOST;
const CMS_API_PORT = process.env.CMS_API_PORT;
const MINDGYM_API_URL = process.env.MINDGYM_API_URL;
const LOGGER_API_URL = process.env.LOGGER_API_URL;
const LOGGER_API_INDEX = process.env.LOGGER_API_INDEX;

export function getProtooUrl({ roomId, peerId }) {
    return `wss://${API_HOST}:${API_PORT}/?roomId=${roomId}&peerId=${peerId}`;
}
export function getAPIUrl() {
    return `https://${API_HOST}:${API_PORT}`;
}

export function getCMSAPIUrl() {
    return `https://${CMS_API_HOST}`;
}

export function getMindGymAPIUrl() {
    return MINDGYM_API_URL;
}

export function getLoggerUrl() {
    return LOGGER_API_URL;
}

export function getLoggerApiIndex() {
    return LOGGER_API_INDEX;
}

